import React from 'react'
import { connect } from 'react-redux'

import LgyLoadingIcon from 'app/components/util/lgy-loading-icon/LgyLoadingIcon'
import LgyAlertDialog from './util/lgy-alert-dialog/LgyAlertDialog'

/**
 * Wrap this around protected components to prevent them from being rendered if the user does not have the correct permissions
 * 
 * @author Nic Ebner
 * @author Alex Clary
 *
 * @param {Object} props Component props
 * @param {Object} props.user the user to authorize, typically the logged-in user
 * @param {String} props.gearName the area of the application being authorized, for fallback messaging
 * @param {Array.<String>} props.gearAuth the authority needed by the user to be authorized to view the child elements
 * @param {Function} props.callback a function that generates JSX. If any JSX is returned, it will be rendered rather than the children elements
 * @param {Array.<ReactElement>} children the child elements of Authorize
 * 
 * @return {ReactElement}
 * 
 * TODO: maybe convert to a HOC?
 * TODO: take another look at callback
 */
const Authorize = ({ user, gearName, gearAuth, callback, children }) => {
  if (user.fetching) {
    return <LgyLoadingIcon />
  } else if (!user.id) {
    return <LgyAlertDialog type='info' heading='Sign In' text={`Please sign in to view ${gearName}.`} />
  } else if (callback) {
    return <div>{callback}</div>
  } else if (gearAuth.some(auth => user.authorizations.includes(auth))) {
    return <div>{children}</div>
  } else {
    return <LgyAlertDialog type='warning' heading='Unauthorized Access' text={`You are not authorized to view ${gearName}.`} />
  }
}

const mapStateToProps = (state) => ({ user: state.currentUser })

export default connect(mapStateToProps)(Authorize)

// Allows Authorize to be used for other users if caller provides the other user as a parameter
export { Authorize as AuthorizeWithUser }
